/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Study_Judaic_Studies18Inputs */

const en__field_enum_study_judaic_studies18 = /** @type {(inputs: _Field_Enum_Study_Judaic_Studies18Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Judaic Studies`)
};

const de__field_enum_study_judaic_studies18 = /** @type {(inputs: _Field_Enum_Study_Judaic_Studies18Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Judaistik`)
};

/**
* | output |
* | --- |
* | "Judaic Studies" |
*
* @param {_Field_Enum_Study_Judaic_Studies18Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_study_judaic_studies18 = /** @type {((inputs?: _Field_Enum_Study_Judaic_Studies18Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Study_Judaic_Studies18Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_study_judaic_studies18(inputs)
	return de__field_enum_study_judaic_studies18(inputs)
});
export { _field_enum_study_judaic_studies18 as "_field_enum_STUDY_JUDAIC_STUDIES" }